
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'CancelFinalize',
    props: {
        periodEndLabel: { type: String, default: '' },
        finalizing: { type: Boolean, default: false },
    },
    emits: ['done'],
});
